import { createApp } from 'vue';
import App from '@/apps/search/App.vue';

export const initSearch = (selector = '#search-app', options = {}) => {
  const app = createApp(App);
  if (options.searchConfig) {
    app.provide('searchConfig', options.searchConfig);
  }
  app.mount(selector);
  return app;
};
